import { makeReparcelingsRepository } from 'modules/customer/infra/repositories';

import { ConfirmReparcelingUseCase } from './implementations/ConfirmReparcelingUseCase';

let instance: ConfirmReparcelingUseCase | null = null;

export default function makeConfirmReparcelingUseCase() {
  if (!instance) {
    const repository = makeReparcelingsRepository();

    instance = new ConfirmReparcelingUseCase(repository);
  }

  return instance;
}
